import {OldCreationStepName, oldCreationSteps} from '@/profile-creation-wizard/config/steps/OldCreationSteps';
import {ProfileCreationFunnelMode, RoutesConfig} from '@/profile-creation-wizard/config/steps/ProfileCreationSteps';
import ProfileCreationRouterHelper from '@/profile-creation-wizard/router/ProfileCreationRouterHelper';

const oldRoutesConfig: RoutesConfig = {
    routes: oldCreationSteps.map((step) => ProfileCreationRouterHelper.buildRouteFromStep(step, ProfileCreationFunnelMode.FREELANCER)),
    creationFirstStep: OldCreationStepName.SIGNUP_HEADLINE,
    completionFirstStep: OldCreationStepName.COMPLETION_DESCRIPTION,
};

export default oldRoutesConfig;
